export default __webpack_public_path__ + "static/media/Reason 3.2828495d.mp3";